import { apiPaths } from "../utils/apiUtils";
import api from "../api/api";

export async function getApplicationKeepAliveApi() {
  try {
    const response = await api.get(`${apiPaths.keepAlive}`);
    
    if (!response || !response.data) {
      throw new Error("Invalid response structure");
    }

    return response.data;
  } catch (error) {
    handleApiError(error, "Session keep-alive error");
    return null;
  }
}

  function handleApiError(error: any, context: any) {
    if (error.name === "CanceledError") {
      console.warn(`[API Canceled]: ${context}`);
      return; // Not logging canceled requests as errors
    }
  
    const status = error.response?.status;
    const message = error.response?.data?.message || error.message;
  
    console.error(`[API Error]: ${context} - Status: ${status || "N/A"}, Message: ${message}`);
  }